import styled from 'styled-components';
import RenderingInfoExtendedContent from './RenderingInfoExtendedContent';


const ContainerExtended = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;


function RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo }) {
    return (
        !isExpanded ? (
            renderGenericContainerCard()
        ) : (
            <ContainerExtended className='container-extended'>
                {renderGenericContainerCard()}
                {RenderingInfoExtendedContent({ matchInfo })}
            </ContainerExtended>
        )
    )
}

export default RenderingMatchWithConditionExtended;